import { withDefault } from "@faedev/editor-utils";
import Text from "src/components/Text";
import { VariantProfileType } from "src/types/VariantProfileType";
import { VariantSize } from "src/types/VariantSize";

function profileName(
  name: string,
  surname: string,
  nickname: string,
  profileType: VariantProfileType,
  size?: VariantSize | null | undefined,
  margin?: string | null | undefined
) {
  return name &&
    surname &&
    !(name + ` ` + surname === nickname) &&
    profileType === `instructor` ? (
    <>
      {name + ` ` + surname}
      {nickname ? (
        size ? (
          <Text
            align="center"
            size={size}
            style={{ marginLeft: withDefault(margin, "calc(0.5em)") }}
          >
            {`(` + nickname + `)`}
          </Text>
        ) : (
          <>{`(` + nickname + `)`}</>
        )
      ) : null}
    </>
  ) : (
    <>{nickname}</>
  );
}

export default profileName;
